var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeacher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 533,
    height: 462,
    viewBox: "0 0 533 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M517.689 282.822C382.469 286.411 306.642 286.642 171.394 284.458",
    stroke: "#B2B1B1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.407 11.3635C267.497 7.80324 358.942 7.95547 522.032 11.3565",
    stroke: "#B2B1B1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M524.441 8.74572C525.731 116.447 524.307 176.79 518.637 284.345",
    stroke: "#B2B1B1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.863 81.096C101.155 54.4552 101.289 39.521 102.304 12.8911",
    stroke: "#B2B1B1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.542 4.6108C273.246 1.05326 365.597 1.20703 530.302 4.6108",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M517.741 286.918C381.239 290.512 304.693 290.746 168.163 288.57",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M529.637 12.8806C531.627 119.105 530.594 178.634 525.623 284.756",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.753 80.4157C96.8351 52.3251 97.045 36.5819 98.4748 8.51472",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M518.611 23.907C520.751 119.908 519.803 173.705 514.983 269.604",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.468 82.4782C107.846 59.4829 108.012 46.5944 109.059 23.6157",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.812 15.6372C273.442 12.0797 361.266 12.2334 517.897 15.6372",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M509.418 275.707C378.607 279.883 305.25 280.076 174.406 277.291",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.14 76.9716C277.935 131.001 241.548 133.022 223.63 127.28L212.604 119.01L183.659 105.227L174.701 99.0244L167.809 86.6197L170.566 65.256L180.214 48.7164L205.712 41.8249L218.117 37.69L227.076 48.7164L253.264 81.7956L280.14 76.9716Z",
    fill: "#868485"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200.888 42.5141C190.551 50.1046 172.632 40.4467 167.119 76.2824C161.607 112.118 200.721 107.364 222.251 127.279C243.782 147.195 254.722 148.393 273.938 140.373C297.28 130.631 315.902 96.1682 296.68 79.7282C283.385 68.3582 268.791 84.2228 251.885 79.7282C228.058 73.3935 229.833 17.7047 200.888 42.5141Z",
    stroke: "black",
    strokeWidth: 5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M211.915 54.9188C204.334 55.8376 188.621 62.3616 186.416 81.1065",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M409.012 163.115C411.768 124.523 380.756 126.82 364.906 132.793L361.46 142.441L338.718 152.778L312.531 160.359L308.396 171.385L312.531 183.101L325.624 194.127L340.786 201.708L368.352 204.464L389.715 194.127L409.012 163.115Z",
    fill: "#241F20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M362.839 138.995C355.12 148.919 331.597 155.075 320.8 156.913C276.287 178.277 370.419 243.057 403.498 175.52C436.578 107.983 393.161 110.74 383.513 112.118C373.865 113.497 372.487 126.59 362.839 138.995Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M249.184 240.384C257.809 255.798 269.063 247.146 273.612 240.894L272.507 236.349L278.591 226.704L286.68 217.247L285.493 212.004L280.979 208.571L273.219 207.648L265.535 208.557L254.328 214.417L248.77 223.716L249.184 240.384Z",
    fill: "#241F20"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M272.845 238.009C273.302 232.289 280.732 224.043 284.389 220.635C296.014 201.325 243.864 200.213 248.177 234.27C252.491 268.327 268.362 256.39 271.697 253.446C275.032 250.501 272.275 245.16 272.845 238.009Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5001 182L83.0001 186.5L77.5001 185.5L74.0001 186.5L71.0001 169V149.5L74.0001 127.5L84.5001 124L100.5 127.5L104 129L112 130.5L110 136L106.5 139L110 153L108.5 162L100.5 173.5L84.5001 182Z",
    fill: "#C8C7C7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 127C109 138 121.1 163.6 93.5 178C80.3 184 81.6667 185.167 84 185",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 127.5C103 128.5 106.9 130.4 110.5 130C114.1 129.6 110.333 136.167 108 139.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 443.5V407.5L88 443.5H105.5L130 436.5L103 306.5L109 300.5L99.5 298L79.5 297L44 300.5L36 308.5L10.5 436.5L27 441.5L44 443.5L59 445L79.5 443.5Z",
    fill: "#241F20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M75 204.5L65.5 208L61.5 221.5L60.5 228L57.5 235H50L43 232L30.5 216.5L16.5 204.5L7.00003 190L15 171.5L32.55 152L30.05 135.5L38.5 111.5L47 102L57.5 95L70.5 97.5L81.5 105L96.5 101.5L106 105L108 114L103 121L96.5 127.5H84.5L89 135L90.5 143L87 148L77.5 143L76 150.5L81.5 159.5L76 169L75 204.5Z",
    fill: "#232020"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M98 127C103.333 123 112.4 113.2 106 106C99.6 98.8 87.3333 103 82 106C76.3333 98.6667 61.1 87.8 45.5 103C32.5 115.5 39 119.5 32.5 130C26 140.5 32.5 146.5 32.5 151.5C32.5 156.5 1.5 178 9.5 195C17.5 212 30.5 212.5 35.5 224C40.5 235.5 57.5 238.5 60 232.5C62.5 226.5 61 206.5 67.5 206.5C74 206.5 75.5 204 76.5 199.5C77.5 195 71.0001 174.5 76.5 168C80.9 162.8 82 158.167 82 156.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5001 127C96.1667 128.167 90.1001 129.8 84.5001 127C77.5001 123.5 95.0001 138 91.0001 144C87.8001 148.8 85.3334 147.667 84.5001 146.5C82.5001 144.667 78.2001 141.8 77.0001 145C75.5001 149 76 157.5 84.5001 156.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 150.5C107.833 150.333 104 149.8 102 149",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.5 135C96.0001 135 97.0001 133.3 95.0001 132.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5001 186C81.8334 186.833 90.9001 189 92.5001 191C94.1001 193 90.5001 200.5 88.5001 204L84.0001 197C95.6667 218 117.5 267.8 111.5 299C108.3 303.8 103.833 305.333 102 305.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 300C62 297.833 103 294.8 111 300",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36 311C26.8333 351.833 9.00001 434.1 11 436.5C13.5 439.5 43 449 78.5 443.5C80.9 442.3 80.5 417.667 80 405.5C81.6667 418.167 85.7 443.5 88.5 443.5C92 443.5 113.5 446 130 436.5C130 430.1 111.833 347 102 306.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31 444C31.1667 448.833 32.6 458.7 37 459.5C42.5 460.5 64.5 457.5 66.5 455C68.1 453 53.5 450.833 46 450",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M102 446C102.833 448.333 106.2 453.1 113 453.5C121.5 454 140 447.5 140 446C140 444.8 126.333 444.167 119.5 444",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41 460.865C36.407 461.219 26.3787 460.96 21.2433 460.808C21.1615 460.807 21.0804 460.805 21 460.801C21.0798 460.803 21.1609 460.806 21.2433 460.808C24.3295 460.844 28.4539 458.818 33 457.064C34.4 457.064 39.6389 460.264 41 460.865Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M116 454.801C111.407 455.156 101.379 454.896 96.2433 454.745C96.1615 454.744 96.0804 454.741 96.0001 454.737C96.0799 454.74 96.161 454.742 96.2433 454.745C99.3296 454.78 103.454 452.755 108 451C109.4 451 114.639 454.201 116 454.801Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0001,
    cy: 161,
    r: 7.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 230L148 237.5L141.5 224L151.5 218L155 219.5L156 221.5L165.5 219.5V224L161.5 230Z",
    fill: "#C8C7C7"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04258 314.133L12.7892 299.437L26.7543 304.866L23.5416 316.077L19.9599 317.369L17.864 316.59L12.2864 324.537L9.21481 321.248L8.04258 314.133Z",
    fill: "#C8C7C7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40 232C32 249.167 14.2 285.7 6.99999 294.5C4.49999 298.5 22 299 36.5 309C41.5 307.5 64 247 74 239.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 223.5C145.333 221 151.8 216.5 155 218.5C158.2 220.5 154.667 222.667 152.5 223.5C155.333 221.667 161.8 218.4 165 220C169 222 166.5 229 148.5 237.5",
    stroke: "black",
    strokeWidth: 3
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5001 213.5C94.5001 217.5 105.5 232.5 114.5 235.5C125.789 236.984 132.466 218.728 139.5 220.5C140.178 219.101 145.893 234.434 150.5 241.5C151.5 242.5 122.5 261.5 118 261.5C114.4 261.5 109.833 257.667 108.5 256",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3102 305.404C26.8774 309.158 25.0826 316.829 21.3663 317.484C17.6499 318.139 18.826 314.164 19.8786 312.095C18.9997 315.354 16.3797 322.108 12.931 323.06C8.62014 324.25 5.79426 317.376 13.4837 299.015",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeacher);
export default __webpack_public_path__ + "static/media/teacher.ef6081c0ea71b926f9193341a9e26f65.svg";
export { ForwardRef as ReactComponent };